export const createImage = (file: File): Promise<HTMLImageElement> => {
  return new Promise(resolve => {
    const image = new Image();
    image.src = URL.createObjectURL(file);
    image.onload = () => {
      resolve(image);
    };
  });
};

export const createCanvas = (image: HTMLImageElement | ImageBitmap): HTMLCanvasElement => {
  const canvas = document.createElement('canvas');
  canvas.width = image.width;
  canvas.height = image.height;
  const context = canvas.getContext('2d');
  if (!context) throw new Error('Cannot create canvas context');
  context.drawImage(image, 0, 0);
  return canvas;
};

export const canvasToBlob = (canvas: HTMLCanvasElement): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const context = canvas.getContext('2d');
    if (!context) throw new Error('Cannot create canvas context');
    canvas.toBlob(blob => {
      if (!blob) {
        reject(new Error('Cannot convert image to blob'));
        return;
      }
      resolve(blob);
    });
  });
};

export const canvasToImageData = (canvas: HTMLCanvasElement): Promise<ImageData> => {
  return new Promise(resolve => {
    const context = canvas.getContext('2d');
    if (!context) throw new Error('Cannot create canvas context');
    resolve(context.getImageData(0, 0, canvas.width, canvas.height));
  });
};

export const createBlurhash = async (canvas: HTMLCanvasElement, ratio: number) => {
  const pixels = await canvasToImageData(canvas);
  const instance = new ComlinkWorker<typeof import('./BlurhashWorker')>(new URL('./BlurhashWorker', import.meta.url));
  const hash = await instance.createBlurhash(pixels.data, pixels.width, pixels.height, ratio);
  return hash;
};
